import { createSelector } from 'reselect';
import { formatDate } from '../util';
import { initialState } from '../reducers/tools/decisionTree/previousRefunds';

const previousRefunds = (state) => state.tools.decisionTree.previousRefunds || initialState;

const selectLoading = createSelector(previousRefunds, (state) => state.loading);
const selectError = createSelector(previousRefunds, (state) => state.error);

const selectPreviousRefunds = createSelector(previousRefunds, (state) => {
  return state.data.reduce((acc, refund) => {
    return acc.concat(
      refund.transactions
        .filter((t) => t.kind === 'refund' && t.status === 'success')
        .map((t) => ({ dateOfRefund: formatDate(t.processed_at), amount: t.amount, currency: t.currency }))
    );
  }, []);
});

export { selectPreviousRefunds, selectLoading, selectError };
